<template>
  <div class="d-flex flex-column mx-auto p-3 w-100 h-100 cover-container dark-theme">
    <main
      id="loginMain"
      class="form-signin"
    >
      <form>
        <section
          class="login_section"
          style="width:100%"
        >
          <ul>
            <li
              class=""
              style=""
            >
              <img
                class="mb-4"
                :src="slogo"
                alt=""
                width="250"
              >
            </li>
            <li class="" />
            <li class="id_box">
              <input
                id="userid"
                v-model="userid"
                type="text"
                name="z_username"
                placeholder="사용자 아이디 입력"
                class="input_login"
                maxlength="64"
                style="width:220px; background-color:#c5ccd0"
                @keyup.enter="enterKey"
              >
            </li>
            <li class="pw_box">
              <input
                id="password"
                v-model="password"
                type="password"
                name="z_password"
                placeholder="비밀번호 입력"
                class="input_login"
                maxlength="64"
                style="width:220px; background-color:#c5ccd0"
                autocomplete="off"
                @keyup.enter="enterKey"
              >
            </li>
	            
            <div
              class="form-group"
              style="text-align:left"
            >
              <input
                id="idsavehecked"
                v-model="saveCredentials"
                class="check-input"
                type="checkbox"
              >
              <label class="col-form-label">아이디/비밀번호 저장</label>
            </div>
            <li class="btn_box">
              <a
                class="btn_login"
                style="cursor:pointer"
                @click="login"
              >로그인</a>
            </li>
          </ul>
        </section>
      </form>
    </main>
  </div>
</template>

<script setup lang="ts">

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
//import { useAuthStore } from '../stores/auth'
import slogo from '@/assets/images/smartlink_logo_login.png'
import axios from 'axios'

const router = useRouter()
//const auth = useAuthStore()

const userid = ref('')
const password = ref('')
const saveCredentials = ref(false)

// 쿠키 저장 함수
function setCookie(name: string, value: string, days: number) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`
}

// 쿠키 가져오기 함수
function getCookie(name: string): string {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length))
  }
  return ''
}

// 쿠키 삭제 함수
function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
}

// 페이지 로드 시 저장된 정보 불러오기
onMounted(() => {
  const savedChecked = getCookie('saveCredentials')

  // 체크박스가 체크된 상태로 저장되어 있을 때만 아이디/비밀번호 불러오기
  if (savedChecked === 'true') {
    const savedUserid = getCookie('savedUserid')
    const savedPassword = getCookie('savedPassword')

    if (savedUserid && savedPassword) {
      userid.value = savedUserid
      password.value = savedPassword
      saveCredentials.value = true
    }
  } else {
    userid.value = ''
    password.value = ''
  }
})

// 체크박스 변경 감지 - 체크 해제 시 쿠키 삭제 및 입력 필드 초기화
watch(saveCredentials, (newValue) => {
  if (!newValue) {
    // 체크박스 해제 시 쿠키 삭제
    deleteCookie('savedUserid')
    deleteCookie('savedPassword')
    deleteCookie('saveCredentials')
    // 입력 필드 초기화
    userid.value = ''
    password.value = ''
  }
})

function login() {
  console.log("login button ", userid.value, password.value)
  if(!userid.value) {
		alert('사용자 아이디를 입력해 주세요.~~~');
		return;
	}

	if(!password.value) {
		alert('사용자 비밀번호를를 입력해 주세요.~~~');
		return;
	}

    doLogin(userid.value, password.value);
}

function enterKey() {
  login();
}

async function doLogin(username:string, password:string) {
  try {
    const response = await axios.post('/api/login', {
      username,
      password
    });
    if (response.data.success) {
      console.log('로그인 성공:', response.data.user);

      // 아이디/비밀번호 저장 옵션 처리
      if (saveCredentials.value) {
        // 쿠키에 30일 동안 저장
        setCookie('savedUserid', username, 30)
        setCookie('savedPassword', password, 30)
        setCookie('saveCredentials', 'true', 30)
      } else {
        // 체크 해제 시 쿠키 삭제
        deleteCookie('savedUserid')
        deleteCookie('savedPassword')
        deleteCookie('saveCredentials')
      }

      router.push('/main/monitor')
    } else {
      console.error('로그인 실패:', response.data.message);
    }
  } catch (error) {
    console.error('로그인 요청 에러:', error);
  }
}


</script>

<style scoped>
/* 어두운 테마 적용 */
.dark-theme {
  background-color: #1a1a1a !important;
  color: #e0e0e0 !important;
  min-height: 100vh;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #1a1a1a;
}

/* #loginMain {
  width: 300px;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
} */

ul {
  list-style-type: none;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  /*padding: 15px;
  padding-left : 70px;
  padding-right: 70px;*/
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="userid"] {
  margin-bottom: 20px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}




/* input 요소에 직접 적용 - 가장 높은 우선순위 */
.login_section li.id_box input.input_login,
.login_section li.pw_box input.input_login,
input.input_login,
.input_login {
  border: 0 !important;
  height: 40px !important;
  background-color: #2d2d2d !important;
  background-image: none !important;
  padding-left: 10px !important;
  padding-top: 1px !important;
  font-size: 14px !important;
  color: #e0e0e0 !important;
  border-radius: 0 3px 3px 0 !important;
  opacity: 1 !important;
}

.input_login::placeholder {
  color: #888888 !important;
}


.login_section {
  width: 289px;
  background: transparent;
  border-radius: 3px;
}

/* 체크박스 레이블 색상 */
.dark-theme .form-group label {
  color: #e0e0e0 !important;
}

.login_section2 {
  position: absolute;
  top: 480px;
  left: 654px;
  padding-left: 29px;
  padding-top: 53px;
  width: 289px;
  height: 229px;
  background: transparent;
  border-radius: 3px;
}

.login_section li {
  width: 219px;
}

.login_section li.id_box {
  height: 40px;
  margin-bottom: 12px;
  padding-left: 40px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg fill='%23e0e0e0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 24px auto;
  background-repeat: no-repeat;
  background-color: #2d2d2d !important;
  background-position: 8px 50%;
  border-radius: 3px;
}

.login_section li.pw_box {
  height: 40px;
  margin-bottom: 12px;
  padding-left: 40px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg fill='%23e0e0e0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 24px auto;
  background-repeat: no-repeat;
  background-color: #2d2d2d !important;
  background-position: 8px 50%;
  border-radius: 3px;
}

.login_section li.btn_box {
  height: 58px;
}

.login_section li.btn_box a.btn_login {
  display: inline-block;
  width: 260px;
  height: 42px;
  color: #ffffff;
  font-size: 16px;
  font-weight: normal;
  line-height: 38px;
  background: #535b5f;
  border-radius: 3px;
  text-align: center !important;
}
.login_section li.btn_box a.btn_login:hover, .login_section li.btn_box a.btn_login:focus {
  background-color: #5f686d;
}
.login_section li.btn_box a.btn_login:active {
  background-color: #474e51 !important;
}
</style>
